<template>
  <div class="recruitInfo-container">
    <el-row>
      <zr-query-form class="query-box">
        <zr-query-form-left-panel>
          <el-form :inline="true" :model="queryForm" @submit.native.prevent>
            <el-form-item :label="isMb ? '' : '职位名称'">
              <el-input
                v-model.trim="queryForm.postInfoName"
                placeholder="输入名称点击搜索"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="primary" @click="queryData"
                >查询
              </el-button>
            </el-form-item>
          </el-form>
        </zr-query-form-left-panel>
      </zr-query-form>
    </el-row>
    <!--    <el-row style="margin: 5px 15px">
      <a @click="writeOnLineCount()>{ onlineTotal }</a>
    </el-row>-->
    <el-row class="tagsBox">
      <el-col :lg="16" :sm="12" :xs="12" style="margin-top: 9px">
        <el-tag
          v-if="showTag"
          :class="activeName == 'online' ? 'tagActive' : ''"
          type="info"
          @click="writeOnLineCount"
          >在线{{ "(" + onlineTotal + ")" }}</el-tag
        >
        <el-tag
          v-if="showTag"
          :class="activeName == 'offline' ? 'tagActive' : ''"
          type="info"
          @click="offlineOnclick"
          >下线{{ "(" + offLineNum + ")" }}</el-tag
        >
      </el-col>
      <el-col v-if="isManager" :lg="8" :sm="12" :xs="12">
        <div v-if="isMb">
          <el-button
            type="primary"
            style="margin-top: 5px; margin-right: 10px; float: right"
            @click="positionPublish"
          >
            职位发布<i class="fa fa-plus"></i>
          </el-button>
          <el-button
              type="info"
            style="margin-top: 5px; margin-right: 55px; float: right"
            @click="positionImport"
          >
            职位导入<zr-icon icon="arrow-up"></zr-icon>
          </el-button>
          <el-button
              type="info"
              style="margin-top: 5px; margin-right: 55px; float: right"
              @click="resumeExcelExport"
          >
            职位数据导出<zr-icon icon="download"></zr-icon>
          </el-button>
        </div>
        <div v-else>
          <el-button
            type="primary"
            style="margin-top: 5px; margin-right: 10px; float: right"
            @click="positionPublish"
          >
            职位发布<i class="fa fa-plus"></i>
          </el-button>
          <el-button
              type="info"
            style="margin-top: 5px; margin-right: 10px; float: right"
            @click="positionImport"
          >
            职位导入<zr-icon icon="arrow-up"></zr-icon>
          </el-button>
          <el-button
              type="info"
              style="margin-top: 5px; margin-right: 10px; float: right"
              @click="resumeExcelExport"
          >
            职位数据导出<zr-icon icon="download"></zr-icon>
          </el-button>
        </div>
      </el-col>
    </el-row>
    <div v-if="showPage" style="margin: 10px 5px">
      <el-row v-for="post in list" :key="post.id" class="postInfo" :gutter="10">
        <el-col :lg="16" :sm="12" :xs="12">
          <el-row class="p-first"
            ><el-link
              :underline="false"
              type="primary"
              class="content-break"
              @click="gotoPost(post)"
              ><span class="name">{{ post.name }}</span
              ><span class="science">{{ post.science }}</span></el-link
            ></el-row
          >
          <el-row class="p-second"
            ><span class="careerRequire">{{ post.careerRequire }}</span
            ><span class="eduRequire">{{
              eduRequireFormat(post.eduRequire, post.eduRequireAndOver)
            }}</span>
            <span class="requireNum">{{
              post.requireNum > 0 ? post.requireNum + "人" : "人数不限"
            }}</span></el-row
          >
          <el-row class="p-third">
            <span class="publishDate">{{ dateFormat(post.publishDate) }}</span>
            至
            <span class="endDate">{{ dateFormat(post.endDate) }}</span>
          </el-row>
        </el-col>
        <el-col :lg="2" :sm="3" :xs="3">
          <a @click="gotoResume(post)">
            <div class="postCount">
              {{ post.postCount ? post.postCount : 0 }} <br /><span>投递</span>
            </div>
          </a>
        </el-col>
        <el-col :lg="2" :sm="3" :xs="3">
          <div class="viewCount">
            {{ post.viewCount ? post.viewCount : 0 }} <br /><span>浏览</span>
          </div>
        </el-col>
        <el-col v-show="isShow" v-if="isManager" :lg="2" :sm="3" :xs="3"
          ><el-button
            type="primary"
            style="margin-top: 5px; margin-left: 5px"
            @click="modifyPostInfo(post.id)"
            ><zr-icon icon="edit"></zr-icon>
            <span class="hidden-sm-and-down" />{{
              isMb ? "" : "修改职位"
            }}</el-button
          >
          <el-button
            type="info"
            style="margin-top: 2px; margin-bottom: 5px; margin-left: 5px"
            @click="copyPostInfo(post.id)"
            ><zr-icon icon="copy"></zr-icon>
            <span class="hidden-sm-and-down" />{{
              isMb ? " " : " 复制职位"
            }}</el-button
          >
        </el-col>
        <el-col v-if="isManager" v-show="isShowOnline" :lg="2" :sm="3" :xs="3"
          ><el-button
            type="warning"
            style="margin-top: 20px"
            @click="onlinePostInfo(post.id)"
            ><zr-icon icon="arrow-up"></zr-icon>
            <span class="hidden-sm-and-down">上线职位</span></el-button
          ></el-col
        >
        <el-col v-if="isManager" v-show="isShowOnline" :lg="2" :sm="3" :xs="3">
          <!--          <el-button-->
          <!--            type="success"-->
          <!--            style="margin-top: 20px"-->
          <!--            @click="resumePackage(post.id)"-->
          <!--            ><zr-icon icon="download"></zr-icon>-->
          <!--            <span class="hidden-sm-and-down">简历打包</span></el-button-->
          <!--          >-->
          <el-dropdown
            @command="
              (command) =>
                handleCommand(command, post.id, post.name, post.postCount)
            "
          >
            <el-button type="success" style="margin-top: 20px"
              ><zr-icon icon="download"></zr-icon>
              <span class="hidden-sm-and-down">简历打包</span></el-button
            >
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="pdf">pdf下载</el-dropdown-item>
              <el-dropdown-item command="word">word下载</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
        <el-col v-if="isManager" v-show="isShow" :lg="2" :sm="3" :xs="3"
          ><el-button
            type="warning"
            style="margin-top: 20px"
            @click="cancelOnlinePostInfo(post.id)"
            ><zr-icon icon="arrow-down"></zr-icon>
            <span class="hidden-sm-and-down">下线职位</span></el-button
          ></el-col
        >
      </el-row>
      <el-row><div class="rowLine"></div></el-row>
    </div>

    <el-pagination
      v-if="showPage"
      ref="elPage"
      class="page-box"
      background
      :page-sizes="pageSizes"
      :page-size="pageSize"
      :current-page="currentPage"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float: right; padding-right: 5px; margin-bottom: 15px"
      @current-change="currentPageChange"
      @size-change="pageSizeChange"
    ></el-pagination>
    <post-info-excel-import ref="postInfoExcelImport"></post-info-excel-import>
  </div>
</template>

<script>
import { defaultPageSizes } from "@/config/settings";
import {
  getPage,
  getUnderLinePostInfoCount,
  getOnlinePostInfoCount,
  cancelOnlinePostInfo,
  onlinePostInfo,
} from "@/api/recruit/hr/positionManagement";
import { mapGetters } from "vuex";
import { getBasicData } from "@/api/job/postInfo";
import { messageDuration } from "../../../config/settings";
import isMobile from "@/utils/device";
import store from "@/store";
import { downloadFile } from "@/utils/downFile";
import PostInfoExcelImport from "^/zr/dialog/postInfoExcelImport.vue";

let query = undefined;
const isMb = isMobile();
export default {
  name: "Index",
  components: {PostInfoExcelImport},
  data() {
    return {
      isMb: isMb,
      showPage: true,
      showTag: true,
      isShow: true,
      isShowOnline: false,
      activeName: "online",
      currentPage: 1,
      pageInfo: {},
      filterProps: {},
      pageSize: defaultPageSizes[0],
      onlineTotal: 0,
      offLineNum: 0,
      isOnline: "1",
      scienceTypeArray: [],
      eduTypeArray: [],
      queryForm: {
        postInfoName: "",
      },
      list: [],
      pageSizes: defaultPageSizes,
      total: 0,
      pageLayout: "total, sizes, prev, pager, next, jumper",
    };
  },
  computed: {
    ...mapGetters({
      curRole: "user/curRole",
    }),
    isManager() {
      return this.curRole == "hrAdmin" || this.curRole == "admin";
    },
  },
  async created() {
    if (query) {
      this.showPage = false;
      this.showTag = false;
      /*this.activeName = query.activeName ? query.activeName : "online";*/
      if (query.pageInfo && typeof query.pageInfo == "object") {
        this.pageSize = query.pageInfo.pageSize;
        this.currentPage = query.pageInfo.pageIndex;
      }
      if (query.filterProps && typeof query.filterProps == "object") {
        if (query.filterProps.isOnline) {
          if (query.filterProps.isOnline === "0") {
            this.activeName = "offline";
          } else {
            this.activeName = "online";
          }
        }
        this.filterProps = query.filterProps;
        this.queryForm.postInfoName = query.filterProps.postInfoName;
        this.isOnline = query.filterProps.isOnline;
      }
      this.$nextTick(() => {
        this.showPage = true;
        this.showTag = true;
      });
    }
    await this.writeUnderLineCount();
    await this.getOnlinePostInfoCount();
    await this.getScienceArray();
    await this.getEduTypeArray();
    await this.refreshPage();
  },
  beforeRouteEnter(to, from, next) {
    const preName = from.name;
    query = undefined;
    if (
      preName == "PositionView" ||
      preName == "PositionEdit" ||
      preName == "ResumeManagement"
    ) {
      query = from.query;
    }
    next();
  },
  methods: {
    queryData() {
      this.filterProps.postInfoName = this.queryForm.postInfoName;
      this.currentPage = 1;
      this.refreshPage();
    },
    //查询下线职位数量
    async writeUnderLineCount() {
      let res = await getUnderLinePostInfoCount();
      if (res.success) {
        this.offLineNum = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    //查询上线职位数量
    async getOnlinePostInfoCount() {
      let res = await getOnlinePostInfoCount();
      if (res.success) {
        this.onlineTotal = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    async offlineOnclick() {
      this.activeName = "offline";
      this.isShow = false;
      this.isShowOnline = true;
      this.isOnline = "0";
      this.currentPage = 1;
      await this.refreshPage();
    },
    async writeOnLineCount() {
      this.activeName = "online";
      this.isShow = true;
      this.isShowOnline = false;
      this.isOnline = "1";
      this.currentPage = 1;
      await this.refreshPage();
    },

    handleClick(name) {
      this.activeName = name;
    },
    //学科类别
    async getScienceArray() {
      let res = await getBasicData({ typeCode: "scienceType" });
      if (res.success) {
        this.scienceTypeArray = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    //学历分类
    async getEduTypeArray() {
      let res = await getBasicData({ typeCode: "eduRequire" });
      if (res.success) {
        this.eduTypeArray = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    gotoPost(post) {
      this.$router.push({
        path: "/positionView/index",
        query: {
          positionInfoId: post.id,
          pageInfo: this.pageInfo,
          filterProps: this.filterProps,
        },
      });
    },
    //职位数据导出
    async resumeExcelExport() {
      this.$confirm(
          "确认要进行职位数据导出导出吗？"
      )
          .then(async () => {
            const token = store.getters["user/accessToken"];
            await downloadFile("/postInfo/resumeExcelExport", {
              deptCode: this.$store.getters["user/deptCode"],
              token: token,
            });
          })
          .catch((e) => {
            this.$message.info({ showClose: true, message: "已取消导出" });
          });
    },
    positionPublish() {
      this.$router.push({ path: "/positionEdit/index" });
    },
    positionImport() {
      this.$confirm(
          "确认要进行职位导入吗？"
      )
          .then(async () => {
            const token = store.getters["user/accessToken"];
            this.$refs.postInfoExcelImport.open();
          })
          .catch((e) => {
            this.$message.info({ showClose: true, message: "已取消导入" });
          });
    },
    //下线职位
    async cancelOnlinePostInfo(id) {
      this.$confirm("确认要下线该职位吗？").then(async () => {
        //修改是否上线状态：isOnline是否上线(1:上线 0：下线)
        let res = await cancelOnlinePostInfo({ id: id });
        if (res.success) {
          this.$message.success({
            showClose: true,
            message: "下线成功",
            duration: messageDuration,
          });
          await this.writeUnderLineCount();
          await this.getOnlinePostInfoCount();
          await this.refreshPage();
        } else {
          this.$message.error({ showClose: true, message: res.message });
        }
      });
    },
    //上线职位
    async onlinePostInfo(id) {
      this.$confirm("确认要上线该职位吗？").then(async () => {
        //修改是否上线状态：isOnline是否上线(1:上线 0：下线)
        let res = await onlinePostInfo({ id: id });
        if (res.success) {
          this.$message.success({
            showClose: true,
            message: "上线成功",
            duration: messageDuration,
          });
          await this.writeUnderLineCount();
          await this.getOnlinePostInfoCount();
          await this.refreshPage();
        } else {
          this.$message.error({ showClose: true, message: res.message });
        }
      });
    },
    handleCommand(command, id, name, postCount) {
      if (postCount <= 0) {
        this.$message.warning({
          showClose: true,
          message: "该职位没有投递简历,无法打包下载",
          duration: messageDuration,
        });
      } else {
        if (command == "pdf") {
          this.pdfPackage(id, name);
        } else if (command == "word") {
          this.wordPackage(id, name);
        }
      }
    },
    //pdf打包下载
    async pdfPackage(id, name) {
      this.$confirm(
        "下载以pdf形式的简历zip包么？将会用较长时间打包投递该职位的所有简历。"
      ).then(async () => {
        const token = store.getters["user/accessToken"];
        downloadFile("/resumePDF/getOfflineResumePdfZip", {
          id: id, // postInfoId
          // name: name, // postInfoName
          token: token,
        });
        this.$message.warning({
          showClose: true,
          message: "生成简历较慢，请耐心等待...",
          duration: messageDuration,
        });
      });
    },
    //word打包下载
    async wordPackage(id, name) {
      this.$confirm(
        "下载以word形式的简历zip包么？将会用较长时间打包投递该职位的所有简历。"
      ).then(async () => {
        const token = store.getters["user/accessToken"];
        downloadFile("/resumeWord/getOfflineResumeWordZip", {
          id: id, // postInfoId
          // name: name, // postInfoName
          token: token,
        });
        this.$message.warning({
          showClose: true,
          message: "生成简历较慢，请耐心等待...",
          duration: messageDuration,
        });
      });
    },
    gotoResume(post) {
      if (post.postCount) {
        if (this.curRole == "user" || this.curRole == "anonymous") {
          this.$message.warning({
            showClose: true,
            message: "不支持当前功能！",
          });
        } else {
          this.$router.push({
            path: "/resumeManagement/index",
            query: {
              positionInfoId: post.id,
              pageInfo: this.pageInfo,
              filterProps: this.filterProps,
              isPositionGo: true,
            },
          });
        }
      }
    },
    //修改职位
    async modifyPostInfo(id) {
      this.$router.push({
        path: "/positionEdit/index",
        query: {
          positionInfoId: id,
          activeName: this.activeName,
          pageInfo: this.pageInfo,
          filterProps: this.filterProps,
        },
      });
      await this.refreshPage();
    },
    //复制职位
    async copyPostInfo(id) {
      this.$router.push({
        path: "/positionEdit/index",
        query: {
          copy: true,
          positionInfoId: id,
          activeName: this.activeName,
          pageInfo: this.pageInfo,
          filterProps: this.filterProps,
        },
      });
      await this.refreshPage();
    },
    async currentPageChange(val) {
      this.currentPage = val;
      await this.refreshPage();
    },
    async pageSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      await this.refreshPage();
    },
    async refreshPage() {
      this.showPage = false;
      this.filterProps.isOnline = this.isOnline;
      this.filterProps.deptCode = this.$store.getters["user/deptCode"];
      this.pageInfo = {
        pageSize: this.pageSize,
        pageIndex: this.currentPage,
      };
      this.pageInfo.filterProps = this.filterProps;
      let data = await getPage(this.pageInfo);
      if (data.success) {
        this.list = data.data.data;
        for (let i = 0; i < this.list.length; i++) {
          if (!this.list[i].viewCount) {
            this.list[i].viewCount = 0;
          }
          if (!this.list[i].postCount) {
            this.list[i].postCount = 0;
          }
          if (this.list[i].eduRequire) {
            for (let b in this.eduTypeArray) {
              if (this.eduTypeArray[b].code == this.list[i].eduRequire) {
                this.list[i].eduRequire = this.eduTypeArray[b].name;
              }
            }
          }
          if (this.list[i].science) {
            let scienceList = [];
            try {
              scienceList = JSON.parse(this.list[i].science);
            } catch (error) {
              scienceList = this.list[i].science.split(",");
            }
            let scienceString = "";
            for (let c = 0; c < scienceList.length; c++) {
              for (let j in this.scienceTypeArray) {
                if (this.scienceTypeArray[j].code == scienceList[c]) {
                  scienceString += this.scienceTypeArray[j].name + ",";
                }
              }
            }
            scienceString = scienceString.substr(0, scienceString.length - 1);
            this.list[i].science = scienceString;
          }
        }
        this.total = data.data.total;
      } else {
        this.$message.error({ showClose: true, message: data.message });
      }
      /*if (this.isOnline === "1") {
        this.onlineTotal = data.data.total;
      }*/

      this.$nextTick(() => {
        this.showPage = true;
      });
    },
    eduRequireFormat(value, over) {
      const result = this.eduTypeArray.filter((val) => val.code == value);
      const isover = over === 0 ? "" : "及以上";
      return result[0] ? result[0].name + isover : value + isover;
    },
    dateFormat(value) {
      if (value && typeof value == "string") {
        return value.substr(0, 10);
      } else {
        return value;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "public/static/scss/commTableLayouts";
.postInfo {
  mini-height: 80px;
  table-layout: fixed;
  position: relative;
  overflow: hidden;
  flex: 1;
  width: 100%;
  max-width: 100%;
  font-size: 12px;
  color: #606266;

  .p-first,
  .p-second,
  .p-third {
    margin-top: 5px;
  }

  .science,
  .eduRequire,
  .requireNum {
    margin-left: 20px;
  }
  .name {
    font-weight: bold;
  }

  .postCount,
  .viewCount {
    position: relative;
    height: 100%;
    text-align: center;
    font-size: 30px;
    //font-weight: bold;
    color: #44aaee;

    span {
      font-size: 12px;
      color: #44aaee;
    }
  }
}

.postInfo:nth-child(odd) {
  background-color: #fafafa;
}

.postInfo:nth-child(even) {
  background-color: #ffffff;
}

.tagActive {
  background-color: #44aaee;
  color: whitesmoke;
}
.tagsBox {
  //margin-top: 20px;
  margin-left: 10px;
  span {
    cursor: pointer;
  }
}

.button_publish {
  float: right;
  width: 150px;
  background-color: #3395e8;
  height: 35px;
  text-align: center;
  color: #ffffff;
  line-height: 35px;
  cursor: pointer;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.button_publish span {
  float: left;
  margin-left: 35px;
  margin-right: 10px;
}
.button_publish i {
  float: left;
  width: 32px;
  height: 38px;
  background: url(../yuanDesc/images/add.png) 50% 50% no-repeat;
}

.btnbox {
  float: right;
  width: 15%;
  height: 90px;
  margin: 5px 0px;
  border-left: 1px solid #e5e5e5;
}
.btnbox span {
  margin-left: 13px;
  float: left;
  height: 35px;
  line-height: 35px;
  background-color: #3395e8;
  font-size: 12px;
  width: 70px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  margin-top: 30px;
  border-radius: 5px;
}

@mixin row-line {
  content: " ";
  height: 1px;
  width: 100%;
  background-color: #ebeef5;
}

.content-break {
  white-space: pre-wrap;
  display: block;
  word-wrap: break-word;
  overflow: hidden;
}

.postInfo:before {
  @include row-line;
}

.rowLine {
  @include row-line;
}
</style>
